import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function LandingHero(): ReactElement {
  const { t } = useTranslation('common')

  return (
    <section className="lp-hero">
      <img className="lp-hero-watermark" src="/evidenx-key-logo.png" alt="" aria-hidden="true" />
      <p className="lp-hero-eyebrow">{t('landing.hero.eyebrow')}</p>
      <div className="lp-hero-title">
        <span className="lp-hero-line-1">{t('landing.hero.line1')}</span>
        <div className="lp-hero-line-2">
          <span className="lp-hero-line-2-soehne">{t('landing.hero.subtitle')}</span>
        </div>
        <div className="lp-hero-line-2">
          <span className="lp-hero-line-2-sans">{t('landing.hero.builtFor')}</span>
        </div>
        <span className="lp-hero-line-3">{t('landing.hero.punchline')}</span>
        <p className="lp-hero-line-2-soehne">{t('landing.hero.keyLine')}</p>
      </div>
      <p className="lp-hero-supporting">{t('landing.hero.supporting')}</p>
      <div className="lp-hero-meta">
        <span className="lp-hero-meta-item">{t('landing.hero.metaIR')}</span>
        <span className="lp-hero-meta-item">{t('landing.hero.metaCorrelation')}</span>
        <span className="lp-hero-meta-item">{t('landing.hero.metaSovereign')}</span>
        <span className="lp-hero-meta-item">{t('landing.hero.metaYear')}</span>
      </div>
    </section>
  )
}
